import React from 'react'
import { useForm } from '../../forms/hocs/form.context'
import { ZeroResultsMessage, ZeroResultsMessageModal } from './zero-results'
import { useSearchViewState } from '../../contexts/search-view-state-context'

export const ZeroResults = () => {
    const { loading } = useForm()
    const { showSearchFilter } = useSearchViewState()
    if (loading) {
        return null
    }
    return showSearchFilter ? <ZeroResultsMessageModal /> : <ZeroResultsMessage />
}
